module.exports = __webpack_public_path__ + "img/clapperboard-play.350ed1a7.svg";